<fieldset>
  <legend>Select week days</legend>
  @for (day of weekdays(); track day.id) {
    <label class="weekday" [ariaLabel]="day.name">
      <input
        class="weekday-input"
        #checkbox
        type="checkbox"
        name="weekdays"
        [value]="day.id"
        [checked]="day.selected"
        (change)="toggleWeekday(day, checkbox)" />
      <span class="weekday-label lg">{{ day.shortName }}</span>
      <span class="weekday-label sm">{{ day.narrowName }}</span>
    </label>
  }
</fieldset>